import { render, staticRenderFns } from "./NoteIcon.vue?vue&type=template&id=2efd25a9&scoped=true"
import script from "./NoteIcon.vue?vue&type=script&lang=js"
export * from "./NoteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efd25a9",
  null
  
)

export default component.exports